export default __webpack_public_path__ + "static/media/presupuesto.6b995140.svg";